import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    redirect: '/overview',
  },
  { // 注册页面
    path: '/register',
    name: 'register',
    component: () => import('./views/Register.vue'),
  },
  { // 面对面邀请注册页面
    path: '/register2',
    name: 'register2',
    component: () => import('./views/Register2.vue'),
  },
  { // 下载页面
    path: '/download',
    name: 'download',
    component: () => import('./views/Download.vue'),
  },
  { // 可直接通过url访问的下载页面
    path: '/download2',
    name: 'download2',
    component: () => import('./views/Download2.vue'),
  },
  { // 通过itms-services协议直接下载ios app的页面
    path: '/downloadapp',
    name: 'downloadapp',
    component: () => import('./views/DownloadApp.vue'),
  },
  { // itms-services下载ios app的教程页面
    path: '/explainapp',
    name: 'explainapp',
    component: () => import('./views/ExplainApp.vue'),
  },
  { // 恒信通注册协议页面
    path: '/agreement',
    name: 'agreement',
    component: () => import('./views/Agreement.vue'),
  },
  { // 恒信通隐私政策页面
    path: '/policy',
    name: 'policy',
    component: () => import('./views/Policy.vue'),
  },
  { // 共享经济合作伙伴协议页面
    path: '/share',
    name: 'share',
    component: () => import('./views/Share.vue'),
  },
  { // 帮助、意见反馈页面：普通
    path: '/help',
    name: 'help',
    component: () => import('./views/Help.vue'),
  },
  { // 帮助、意见反馈页面，支持：1.在线客服功能
    path: '/help2',
    name: 'help2',
    component: () => import('./views/Help2.vue'),
  },
  { // 帮助、意见反馈页面，支持：1.在线客服功能；2.内容可在后台管理维护
    path: '/help3',
    name: 'help3',
    component: () => import('./views/Help3.vue'),
  },
  { // 帮助、意见反馈页面：送审
    path: '/helpexamine',
    name: 'helpexamine',
    component: () => import('./views/HelpExamine.vue'),
  },
  { // 帮助、意见反馈页面：有公众号二维码
    path: '/helpqrcode',
    name: 'helpqrcode',
    component: () => import('./views/HelpQrcode.vue'),
  },
  { // 业绩页面
    path: '/overview',
    name: 'overview',
    component: () => import('./views/Overview.vue'),
  },
  { // 业绩明细(详情)页面
    path: '/detailed',
    name: 'detailed',
    component: () => import('./views/Detailed.vue'),
  },
  { // 可直接通过url访问的业绩明细(详情)页面
    path: '/detailed2',
    name: 'detailed2',
    component: () => import('./views/Detailed2.vue'),
  },
  { // 进阶指标页面
    path: '/standard',
    name: 'standard',
    component: () => import('./views/Standard.vue'),
  },
  { // 我的代理页面
    path: '/agent',
    name: 'agent',
    component: () => import('./views/Agent.vue'),
  },
  { // 我的代理的明细(详情)页面
    path: '/agentdetail',
    name: 'agentdetail',
    component: () => import('./views/AgentDetail.vue'),
  },
  { // 帮助、意见反馈的明细(详情)页面
    path: '/helpdetail',
    name: 'helpdetail',
    component: () => import('./views/HelpDetail.vue'),
  },
  { // 帮助、意见反馈的明细(详情)页面，支持：1.在线客服功能
    path: '/newhelpdetail',
    name: 'newhelpdetail',
    component: () => import('./views/NewHelpDetail.vue'),
  },
  { // 帮助、意见反馈的明细(详情)页面，支持：1.在线客服功能；2.内容可在后台管理维护
    path: '/newhelpdetailajax',
    name: 'newhelpdetailajax',
    component: () => import('./views/NewHelpDetailAjax.vue'),
  },
  { // 每日额度页面
    path: '/quota',
    name: 'quota',
    component: () => import('./views/Quota.vue'),
  },
  { // 空白页面
    path: '/empty',
    name: 'empty',
    component: () => import('./views/Empty.vue'),
  },
  { // 业绩汇总页面
    path: '/achievement',
    name: 'achievement',
    component: () => import('./views/Achievement.vue'),
  },
  { // 业绩汇总的明细(详情)页面
    path: '/achievementdetail',
    name: 'achievementdetail',
    component: () => import('./views/AchievementDetail.vue'),
  },
  { // 我的商户页面
    path: '/customer',
    name: 'customer',
    component: () => import('./views/Customer.vue'),
  },
  { // 我的商户的明细(详情)页面
    path: '/customerdetail',
    name: 'customerdetail',
    component: () => import('./views/CustomerDetail.vue'),
  },
  { // 分享二维码页面
    path: '/shareqrcode',
    name: 'shareqrcode',
    component: () => import('./views/ShareQrCode.vue'),
  },
  { // 小恒管家任务奖励页面
    path: '/taskreward',
    name: 'taskreward',
    component: () => import('./views/TaskReward.vue'),
  },
  { // 小恒管家任务奖励明细页面
    path: '/taskrewarddetail',
    name: 'taskrewarddetail',
    component: () => import('./views/TaskRewardDetail.vue'),
  },
  { // 小恒助手-任务奖励设置列表
    path: '/taskrewardsettinglist',
    name: 'TaskRewardSettingList',
    component: () => import('./views/TaskRewardSetting/SettingList.vue'),
  },
  { // 小恒助手-任务奖励设置编辑
    path: '/taskrewardsettingedit',
    name: 'TaskRewardSettingEdit',
    component: () => import('./views/TaskRewardSetting/SettingEdit.vue'),
  },
  { // 小恒助手-任务奖励设置明细
    path: '/taskrewardsettingsum',
    name: 'TaskRewardSettingSum',
    component: () => import('./views/TaskRewardSetting/SettingSum.vue'),
  },
  { // 小恒助手-任务奖励设置详情
    path: '/taskrewardsettingdetail',
    name: 'TaskRewardSettingDetail',
    component: () => import('./views/TaskRewardSetting/SettingDetail.vue'),
  },
  { // 流量费设置-列表页
    path: '/flowcostlist',
    name: 'flowcostlist',
    component: () => import('./views/FlowCost/FlowCostList.vue'),
  },
  { // 流量费设置-编辑页
    path: '/flowcostedit',
    name: 'flowcostedit',
    component: () => import('./views/FlowCost/FlowCostEdit.vue'),
  },
  { // 流量费明细-列表页
    path: '/flowcostdetail',
    name: 'flowcostdetail',
    component: () => import('./views/FlowCost/FlowCostDetail.vue'),
  },
  { // 任务统计
    path: '/taskcollect',
    name: 'taskcollect',
    component: () => import('./views/TaskCollect.vue'),
  },
  { // 任务统计明细页面
    path: '/taskcollectdetail',
    name: 'taskcollectdetail',
    component: () => import('./views/TaskCollectDetail.vue'),
  },
  { // 风控管理列表
    path: '/payriskmanagement',
    name: 'payriskmanagement',
    component: () => import('./views/PayRiskManagement.vue'),
  },
  { // 风控管理详情
    path: '/payriskmanagementdetail',
    name: 'payriskmanagementdetail',
    component: () => import('./views/PayRiskManagementDetail.vue'),
  },
  { // 去关注公众号二维码
    path: '/interestpubliccode',
    name: 'interestpubliccode',
    component: () => import('./views/InterestPublicCode.vue'),
  },
  { // 关注公众号后订阅页面
    path: '/interestpublicinput',
    name: 'interestpublicinput',
    component: () => import('./views/InterestPublicInput.vue'),
  },
  { // 关注公众号后注册页面
    path: '/interestpublicregister',
    name: 'interestpublicregister',
    component: () => import('./views/InterestPublicRegister.vue'),
  },
  { // 企业微信-小微商户审核列表页面
    path: '/retailbusinessexaminelist',
    name: 'retailbusinessexaminelist',
    component: () => import('./views/RetailBusinessExamineList.vue'),
  },
  { // 企业微信-小微商户审核编辑页面
    path: '/retailbusinessexamineedit',
    name: 'retailbusinessexamineedit',
    component: () => import('./views/RetailBusinessExamineEdit.vue'),
  },
  { // 企业微信-小微商户审核注册页面
    path: '/retailbusinessexamineregister',
    name: 'retailbusinessexamineregister',
    component: () => import('./views/RetailBusinessExamineRegister.vue'),
  },
  { // 企业微信-图形统计
    path: '/agentinfoecharts',
    name: 'agentinfoecharts',
    component: () => import('./views/AgentInfoEcharts.vue'),
  },
  { // 优惠收款交易明细列表
    path: '/rewardpaylist',
    name: 'rewardpaylist',
    component: () => import('./views/RewardPayList.vue'),
  },
  { // 恒付plus小程序 -- 身份证识别页面
    path: '/IdCardInfo',
    name: 'IdCardInfo',
    component: () => import('@/views/authInfo/IdCardInfo.vue'),
  },
  { // 恒付plus小程序 -- 手持身份证
    path: '/HandIdCard',
    name: 'HandIdCard',
    component: () => import('@/views/authInfo/HandIdCard.vue'),
  },
  { // 恒付plus小程序 -- 人工审核
    path: '/ManualAudit',
    name: 'ManualAudit',
    component: () => import('@/views/authInfo/ManualAudit.vue'),
  },
  { // 恒付plus小程序 -- 身份证过期，补录身份证照片
    path: '/UpdateIdCard',
    name: 'UpdateIdCard',
    component: () => import('@/views/authInfo/UpdateIdCard.vue'),
  },
  { // 恒付plus小程序 -- 身份证认证页面
    path: '/identityIndex',
    name: 'identityIndex',
    component: () => import('@/views/authInfo/identityIndex.vue'),
  },
  { // 恒付plus小程序 -- 手动录入银行卡信息页面
    path: '/manualBankInfor',
    name: 'manualBankInfor',
    component: () => import('@/views/authInfo/manualBankInfor.vue'),
  },
  { // 恒付plus小程序 -- 大额认证页面
    path: '/largeauth',
    name: 'largeauth',
    component: () => import('@/views/authInfo/LargeAuth.vue'),
  },
  { // 恒付plus小程序 -- 关注公众号
    path: '/officialqrcode',
    name: 'OfficialQrCode',
    component: () => import('@/views/authInfo/OfficialQrCode.vue'),
  },
  { // 恒付plus小程序 -- 银行卡解锁编辑页
    path: '/unlockedit',
    name: 'unlockedit',
    component: () => import('@/views/authInfo/UnlockEdit.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 身份证识别页面
    path: '/auth/idcardinfo',
    name: 'AuthInfoNew_IdCardInfo',
    component: () => import('@/views/AuthInfoNew/IdCardInfo.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 新的身份证识别页面：人脸+信用卡
    path: '/auth/idcardauthcredit',
    name: 'AuthInfoNew_IdCardAuthCredit',
    component: () => import('@/views/AuthInfoNew/IdCardAuthCredit.vue'),
  },
  { // 恒付plus小程序：小程序拍照-- 手持身份证
    path: '/auth/handidcard',
    name: 'AuthInfoNew_HandIdCard',
    component: () => import('@/views/AuthInfoNew/HandIdCard.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 人工审核
    path: '/auth/manualaudit',
    name: 'AuthInfoNew_ManualAudit',
    component: () => import('@/views/AuthInfoNew/ManualAudit.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 新的人工审核
    path: '/auth/manualreview',
    name: 'AuthInfoNew_ManualReview',
    component: () => import('@/views/AuthInfoNew/ManualReview.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 身份证过期，补录身份证照片
    path: '/auth/updateidcard',
    name: 'AuthInfoNew_UpdateIdCard',
    component: () => import('@/views/AuthInfoNew/UpdateIdCard.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 大额认证页面 -- H5拍照
    path: '/auth/largeauth',
    name: 'AuthInfoNew_LargeAuth',
    component: () => import('@/views/AuthInfoNew/LargeAuth.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 大额认证页面 -- 小程序拍照
    path: '/auth/largeauthen',
    name: 'AuthInfoNew_LargeAuthen',
    component: () => import('@/views/AuthInfoNew/LargeAuthen.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 身份证识别页面+手写签名功能
    path: '/auth/idcardauthsignature',
    name: 'AuthInfoNew_IdCardAuthSignature',
    component: () => import('./views/AuthInfoNew/IdCardAuthSignature.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 人脸活体检测页面
    path: '/auth/liveface',
    name: 'AuthInfoNew_LiveFace',
    component: () => import('./views/AuthInfoNew/LiveFace.vue'),
  },
  { // 恒付plus小程序：小程序拍照 -- 睡眠用户唤醒页面 2024.9.23
    path: '/auth/sleepuserwakeup',
    name: 'AuthInfoNew_SleepUserWakeUp',
    component: () => import('./views/AuthInfoNew/SleepUserWakeUp.vue'),
  },
  { // 图片页面
    path: '/netUrlPic',
    name: 'netUrlPic',
    component: () => import('./views/netUrlPic.vue'),
  },
  { // 2022.2.18 自动进件商户管理模块
    path: '/posmanagemodule',
    redirect: '/posmanagemodule/index',
  },
  { // 2022.2.18 自动进件商户管理模块首页
    path: '/posmanagemodule/index',
    name: 'PosManageIndex',
    component: () => import('@/views/PosManageModule/Index'),
  },
  { // 2022.2.18 自动进件商户管理模块商户记录列表
    path: '/posmanagemodule/poslist',
    name: 'PosManageList',
    component: () => import('@/views/PosManageModule/PosList'),
  },
  { // 2022.2.18 自动进件商户管理模块商户记录单条详情
    path: '/posmanagemodule/posdetail',
    name: 'PosManageDetail',
    component: () => import('@/views/PosManageModule/PosDetail'),
  },
  { // 2022.2.18 自动进件商户管理模块编辑基本信息首页
    path: '/posmanagemodule/posedit',
    name: 'PosManageEdit',
    component: () => import('@/views/PosManageModule/PosEdit'),
  },
  { // 2022.2.18 自动进件商户管理模块固码绑定
    path: '/posmanagemodule/posbind',
    name: 'PosManageBind',
    component: () => import('@/views/PosManageModule/PosBind'),
  },
  { // 2022.2.18 自动进件商户管理模块商户承诺
    path: '/posmanagemodule/commitment',
    name: 'PosManageCommitment',
    component: () => import('@/views/PosManageModule/Commitment'),
  },
  { // 2022.2.18 自动进件商户管理模块商户承诺
    path: '/posmanagemodule/openpaypage',
    name: 'PosManageOpenPayPage',
    component: () => import('@/views/PosManageModule/OpenPayPage'),
  },
  { // 2022.2.18 自动进件小微活体检测
    path: '/posmanagemodule/livingbody',
    name: 'PosManageLivingBody',
    component: () => import('@/views/PosManageModule/LivingBody'),
  },
  { // 2022.2.18 商户自助注册二维码费率列表
    path: '/posmanagemodule/selfregfeelist',
    name: 'PosManageSelfRegFeeList',
    component: () => import('@/views/PosManageModule/SelfRegFeeList'),
  },
  { // 2022.2.18 商户自助注册二维码费率设置
    path: '/posmanagemodule/selfregfeeedit',
    name: 'PosManageSelfRegFeeEdit',
    component: () => import('@/views/PosManageModule/SelfRegFeeEdit'),
  },
  { // 2022.2.18 商户自助注册二维码显示
    path: '/posmanagemodule/qrcodeshow',
    name: 'PosManageQRCodeShow',
    component: () => import('@/views/PosManageModule/QRCodeShow'),
  },
  { // 2023.2.13 H5自动进件商户管理模块
    path: '/h5posmanagemodule',
    redirect: '/h5posmanagemodule/index',
  },
  { // 2023.2.13 自动进件商户管理模块首页
    path: '/h5posmanagemodule/index',
    name: 'H5PosManageIndex',
    component: () => import('@/views/H5PosManageModule/Index'),
  },
  { // 2023.2.13 自动进件商户管理模块商户记录列表
    path: '/h5posmanagemodule/poslist',
    name: 'H5PosManageList',
    component: () => import('@/views/H5PosManageModule/PosList'),
  },
  { // 2023.2.13 自动进件商户管理模块商户记录单条详情
    path: '/h5posmanagemodule/posdetail',
    name: 'H5PosManageDetail',
    component: () => import('@/views/H5PosManageModule/PosDetail'),
  },
  { // 2023.2.13 自动进件商户管理模块编辑基本信息首页
    path: '/h5posmanagemodule/posedit',
    name: 'H5PosManageEdit',
    component: () => import('@/views/H5PosManageModule/PosEdit'),
  },
  { // 2023.2.13 自动进件商户管理模块固码绑定
    path: '/h5posmanagemodule/posbind',
    name: 'H5PosManageBind',
    component: () => import('@/views/H5PosManageModule/PosBind'),
  },
  { // 2023.2.13 自动进件商户管理模块商户承诺
    path: '/h5posmanagemodule/commitment',
    name: 'H5PosManageCommitment',
    component: () => import('@/views/H5PosManageModule/Commitment'),
  },
  { // 2023.2.13 自动进件商户管理模块商户承诺
    path: '/h5posmanagemodule/openpaypage',
    name: 'H5PosManageOpenPayPage',
    component: () => import('@/views/H5PosManageModule/OpenPayPage'),
  },
  { // 2023.2.13 自动进件小微活体检测
    path: '/h5posmanagemodule/livingbody',
    name: 'H5PosManageLivingBody',
    component: () => import('@/views/H5PosManageModule/LivingBody'),
  },
  { // 2022.4.1 完整注册代理商功能-引导页面
    path: '/enterpriseregisterindex',
    name: 'EnterpriseRegisterIndex',
    component: () => import('@/views/EnterpriseRegister/index'),
  },
  { // 2022.4.1 完整注册代理商功能-注册页面
    path: '/enterpriseregister',
    name: 'EnterpriseRegister',
    component: () => import('@/views/EnterpriseRegister/Register'),
  },
  { // 2022.9.22 业务员管理列表模块
    path: '/businessermanage',
    redirect: '/businessermanage/businesserlist',
  },
  { // 2022.9.22 业务员管理列表
    path: '/businessermanage/businesserlist',
    name: 'BusinesserList',
    component: () => import('@/views/BusinesserManage/BusinesserList'),
  },
  { // 2022.9.22 业务员信息添加
    path: '/businessermanage/businesseradd',
    name: 'BusinesserAdd',
    component: () => import('@/views/BusinesserManage/BusinesserAdd'),
  },
  { // 2022.9.22 业务员信息编辑
    path: '/businessermanage/businesseredit',
    name: 'BusinesserEdit',
    component: () => import('@/views/BusinesserManage/BusinesserEdit'),
  },

  { // 2022.9.22 业务员编辑密码
    path: '/businessermanage/businessereditpwd',
    name: 'BusinesserEditPwd',
    component: () => import('@/views/BusinesserManage/BusinesserEditPwd'),
  },
  { // 2022.9.22 业务员信息详情
    path: '/businessermanage/businesserdetail',
    name: 'BusinesserDetail',
    component: () => import('@/views/BusinesserManage/BusinesserDetail'),
  },
  { // 测试页面
    path: '/test',
    name: 'test',
    component: () => import('./views/Test.vue'),
  },
  ],
});
